import React from 'react';
import PropTypes from 'prop-types';

import { Stack, Typography } from '@mui/material';
import { VpIcon, VpInfoMenu } from '../..';

import { push } from 'react-router-redux';

const IconButonProps = { sx: { borderRadius: '5px' } };

export const SettingsDropdown = ({ items = [], userName, dispatch, logOut }) => {
  const onSelect = (item) => {
    switch (item?.text) {
      case 'Sign Out': {
        logOut();
        return;
      }
      default: {
        dispatch(push(item?.url));
        return;
      }
    }
  };
  const menuButton = (
    <Stack direction="row" gap="10px" alignItems="center">
      <Typography variant="dropDownText" noWrap>
        {userName}
      </Typography>
      <VpIcon icon="ChevronDown" sx={{ width: '14px' }} />
    </Stack>
  );

  return (
    <VpInfoMenu
      id={userName}
      menuItems={items}
      loading={false}
      onSelect={onSelect}
      optionalLabelValue="text"
      IconButtonProps={IconButonProps}
      menuButton={menuButton}
    />
  );
};

SettingsDropdown.propTypes = {
  items: PropTypes.array,
  userName: PropTypes.string,
  logOut: PropTypes.func,
  dispatch: PropTypes.func
};

export default SettingsDropdown;



// WEBPACK FOOTER //
// ./src/vp-ui/components/SettingsDropdown/SettingsDropdown.jsx